// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"e14b4735","453":"3112f1d1","636":"f97fbb44"}[chunkId] + ".chunk.js";
};